import { AiSuggestion, Button } from '@root/components'
import { IAccountingSuggestion } from '@root/query/suggestions'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaMagic, FaTimes } from 'react-icons/fa'
import styled from 'styled-components'

interface IProps {
  suggestion: IAccountingSuggestion
  handleShowContactInput: (show: boolean) => void
}

const ContactSuggestion: React.FC<IProps> = ({ suggestion, handleShowContactInput }) => {
  const isExisting = suggestion.contact != null
  const key = isExisting ? 'existing' : 'new'
  const Icon = FaMagic
  const { t } = useTranslation()

  const label = isExisting
    ? t('contacts.contactSelector.existingContact')
    : t('contacts.contactSelector.newContact')
  const toolTip = isExisting
    ? t('contacts.contactSelector.existingContactToolTip')
    : t('contacts.contactSelector.newContactToolTip')

  return (
    <AiSuggestionWrapper>
      <AiSuggestion
        key={key}
        suggestionDisplayName={suggestion.contact_name}
        label={label}
        icon={<Icon />}
        toolTip={toolTip}
        dismissComponent={
          <SuggestDissmissButton
            isSecondary={true}
            icon={<FaTimes />}
            onClick={() => handleShowContactInput(true)}
            type="button"
          ></SuggestDissmissButton>
        }
      ></AiSuggestion>
    </AiSuggestionWrapper>
  )
}

export default ContactSuggestion

const SuggestDissmissButton = styled(Button)`
  margin-left: auto;
  padding: 0rem !important;
  padding-top: ${({ theme }) => theme.spacing.md}rem !important;

  &:hover,
  &:focus {
    background: transparent !important;
  }
`

const AiSuggestionWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.sm}rem 0;
`
